import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../index.css"
import { Subitle, ParentCard, HorizontalBar, Pagination, PaginationButton, CustomStyle } from "./style";
import Card from '../../components/Card';
import { Button, Input, Container, Stack, Text, Center, VStack } from "@chakra-ui/react";
import Select from "react-select";
import Footer from "../../components/Footer";
import Navigation from "../../components/Navbar";

import APIConfig from "../../api/APIConfig";
import AuthService from "../../services/auth.service";

import "./static/css/index.css";

import ReactLoading from "react-loading";

const category = [
  { value: "Cari posisi", label: "Posisi" },
  { value: "Cari lokasi", label: "Lokasi" },
  { value: "Cari perusahaan", label: "Perusahaan" },
];

function recruitmentTime(string){
    return new Date(string).getMonth();
}

function publishDay(string){
    return new Date(string).getDate();
}
  
const Lowongan = (props) => {
    const [spinner, setSpinner] = useState(false); 
    const [lowongan, setLowongan] = useState([]);
    const [currentUser, setCurrentUser] = useState([]);
    const [showPeserta, setShowPeserta] = useState(false);
    let d = new Date().getDate();

    useEffect(() => {
        const user = AuthService.getCurrentUser();
        if (user) {
            setShowPeserta(user.roles.includes("Peserta"));
            setCurrentUser(user);
        }
    }, [])

    const getLowongan = async() => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/list-lowongan`);
        const result = await response.data;
        setLowongan(result);
        setSpinner(false);
    };

    useEffect(() => {
        getLowongan();
    }, []);

    const [temporarySearch, setTemporarySearch] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [selectedValue, setSelectedValue] = useState("Cari posisi");
    

    const handleChange = (e) => {
        setSelectedValue(e.value);
    };

    let data = lowongan;
    const [currentPage, setCurrentPage] = useState(1);
    const pageNumbers = [];

    const handleSearchChange = (e) => {
        e.preventDefault();
        setTemporarySearch(e.target.value);
    };
    const handleSearchFilter = (e) => {
        e.preventDefault();
        setSearchValue(temporarySearch);
    };

    const matcher = (data) => {
      const home = searchValue.toLocaleLowerCase();
      if (selectedValue === "Cari posisi") {
        if (data.proposal.namaPosisi.toLocaleLowerCase().includes(home)) return true;
      } else if (selectedValue === "Cari lokasi") {
        if (data.proposal.lokasi.toLocaleLowerCase().includes(home)) return true;
      } else if (selectedValue === "Cari perusahaan") {
        if (data.mitra.namaResmi.toLocaleLowerCase().includes(home)) return true;
      }
      return false;
    };
  
    
    data = data.filter((i) => matcher(i));
    
    for (let i = 1; i <= Math.ceil(data.length / 10); i++) {
        pageNumbers.push(i);
    }

    const indexOfLastData = currentPage * 10;
    const indexOfFirstData = indexOfLastData - 10;
    data = data.slice(indexOfFirstData, indexOfLastData);
        
    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }

    return (
        <>
        <Navigation />
        {data.length > 0 ?
        <div>
        <Container margin={'0'} padding={'0'} maxW={'100%'}>
            <Stack className="grid2" spacing={{ base: 5, md: 10 }} fontFamily={'Inter'}>
            <div className="inputdiv">
                  <div className="searchbar" style={{ 
                    display: "flex", alignItems:'center', justifyContent: 'center' }}>
                  <Input
                    className="inputbar"
                    marginRight={'10px'}
                    type="text"
                    placeholder={selectedValue}
                    onChange={handleSearchChange}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") handleSearchFilter(e);
                    }}
                  ></Input>
                  <Select 
                    styles={CustomStyle}
                    defaultValue={{ label: "Cari posisi", value: "Posisi" }}
                    value={category.find((obj) => obj.value === selectedValue)}
                    options={category}
                    onChange={handleChange} />
                  </div>
                  <br></br>
                  <div style={{ 
                    display: "flex", alignItems:'center', justifyContent: 'center' }}>
                    <Button 
                        style={{background: '#6554C0', color: '#FFFFFF', border: '2px solid #6554C0'}}
                        onClick={handleSearchFilter}>
                        Cari
                    </Button>  
                  </div>
                </div>
            </Stack>
        </Container>

        <Container margin={'0'} padding={'0'} maxW={'100%'}>
            <Stack className="grid2" spacing={{ base: 5, md: 10 }} fontFamily={'Inter'}>
                <Subitle>Total Lowongan Tersedia: {data.length}</Subitle>
                {showPeserta &&
                <ParentCard>
                    {data.map((data) => (
                                <Link to={`/lowongan/detail/${currentUser.peserta[0].idPeserta}/${data.idLowongan}`} 
                                    style={{color:'#000000', margin: 'auto', textDecoration: 'none'}}>
                                    <Card 
                                            jabatan={data.proposal.namaPosisi}
                                            perusahaan={data.mitra.namaResmi}
                                            durasi={`${recruitmentTime(data.proposal.tanggalSelesai) - recruitmentTime(data.proposal.tanggalMulai)} bulan`}
                                            lokasi={data.proposal.lokasi}
                                            waktuPost={`${d - publishDay(data.waktuDipublish)} hari yang lalu`}
                                            logo={data.mitra.image}
                                            nominal={data.proposal.nominal}
                                        />
                                </Link>
                        ))}
                    
                    {data.length > 0 ? (<HorizontalBar last={true} />) : null}
                    {pageNumbers.length > 1 && (
                        <Pagination>
                            <PaginationButton onClick={() => 
                                setCurrentPage(1)}>
                                &lt;&lt;
                            </PaginationButton>
                            <PaginationButton onClick={() => 
                                currentPage === 1 ? setCurrentPage(1) : setCurrentPage(currentPage-1)}>
                                &lt;
                            </PaginationButton>
                            {pageNumbers.map((page) => (
                                <PaginationButton
                                    unshow={
                                        currentPage > 2 && pageNumbers.length - currentPage > 1
                                        ? Math.abs(currentPage - page) > 2
                                        : pageNumbers.length - currentPage < 2
                                        ? pageNumbers.length - page > 4
                                        : page > 5
                                    }
                                    active={currentPage === page}
                                    onClick={() => setCurrentPage(page)}
                                    >
                                        {page}
                                </PaginationButton>
                            ))}
                            <PaginationButton
                                onClick={() =>
                                currentPage === pageNumbers.length
                                    ? setCurrentPage(pageNumbers.length)
                                    : setCurrentPage(currentPage + 1)
                                }
                            >
                                &gt;
                            </PaginationButton>
                            <PaginationButton onClick={() => setCurrentPage(pageNumbers.length)}>
                                &gt;&gt;
                            </PaginationButton>
                        </Pagination>
                    )}
                </ParentCard>
                }
                {!showPeserta &&
                <ParentCard>
                    {data.map((data) => (
                                <Link to="/login"
                                    style={{color:'#000000', margin: 'auto', textDecoration: 'none'}}>
                                    <Card 
                                            jabatan={data.proposal.namaPosisi}
                                            perusahaan={data.mitra.namaResmi}
                                            durasi={`${recruitmentTime(data.proposal.tanggalSelesai) - recruitmentTime(data.proposal.tanggalMulai)} bulan`}
                                            lokasi={data.proposal.lokasi}
                                            waktuPost={`${d - publishDay(data.waktuDipublish)} hari yang lalu`}
                                            logo={data.mitra.image}
                                            nominal={data.proposal.nominal}
                                        />
                                </Link>
                        ))}
                    
                    {data.length > 0 ? (<HorizontalBar last={true} />) : null}
                    {pageNumbers.length > 1 && (
                        <Pagination>
                            <PaginationButton onClick={() => 
                                setCurrentPage(1)}>
                                &lt;&lt;
                            </PaginationButton>
                            <PaginationButton onClick={() => 
                                currentPage === 1 ? setCurrentPage(1) : setCurrentPage(currentPage-1)}>
                                &lt;
                            </PaginationButton>
                            {pageNumbers.map((page) => (
                                <PaginationButton
                                    unshow={
                                        currentPage > 2 && pageNumbers.length - currentPage > 1
                                        ? Math.abs(currentPage - page) > 2
                                        : pageNumbers.length - currentPage < 2
                                        ? pageNumbers.length - page > 4
                                        : page > 5
                                    }
                                    active={currentPage === page}
                                    onClick={() => setCurrentPage(page)}
                                    >
                                        {page}
                                </PaginationButton>
                            ))}
                            <PaginationButton
                                onClick={() =>
                                currentPage === pageNumbers.length
                                    ? setCurrentPage(pageNumbers.length)
                                    : setCurrentPage(currentPage + 1)
                                }
                            >
                                &gt;
                            </PaginationButton>
                            <PaginationButton onClick={() => setCurrentPage(pageNumbers.length)}>
                                &gt;&gt;
                            </PaginationButton>
                        </Pagination>
                    )}
                </ParentCard>
                }
            </Stack>
        </Container>
        </div>
        :
        <Container margin={'0'} padding={'80px'} maxW={'100%'} textAlign={"center"}>
            <Stack className="grid2" spacing={{ base: 5, md: 10 }} fontFamily={'Inter'}>
                <Text fontSize={"x-large"} fontWeight={'600'}>Belum ada lowongan</Text>
            </Stack> 
        </Container>
        }
        <Footer />
        </>
    );
}

export default Lowongan;